<template>
  <div class="vx-row">
    <div class="w-full vx-col">
        <vx-card  titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="mb-8 user-list-filters" :collapse-action="true">
            <div class="vx-row">
                <div class="w-full vx-col md:w-1/3 sm:w-1/2">
                    <label class="text-sm opacity-100 text-bold">Name</label>
                    <vs-input type="search"  placeholder="Search.." v-model="filters['name']" class="w-full mb-4 md:mb-0"/>
                </div>
            </div>
            <div class="mt-5 vx-row">
                <div class="w-full ml-auto vx-col">
                    <vs-button class="float-right mr-4" size="small"
                                color="danger" type="border" icon-pack="feather" v-on:click="filters={}" >CLEAR</vs-button>
                </div>
            </div>
        </vx-card>
      <vx-card :title="'SAGE DEPARTMENTS'" class="">
        <template slot="actions">
          <vs-button @click.stop="onClickAdd" icon-pack="feather" icon="icon-plus" class="mr-4"  color="primary" type="filled">create</vs-button>
        </template>
        <div id="sage-department-table" class="vx-row">
          <div class="w-full vx-col">

            <vs-table stripe sort class="mt-8" :data="sage_departments">
              <template slot="thead">
                <vs-th width="25%">Name</vs-th>
                <vs-th width="40%">Sage Nominal Codes</vs-th>
                <vs-th width="10%">Action</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>

                   <vs-td :data="data[indextr].sage_nominal_codes">
                    <span v-for="(nominal_code, index_nominal) in data[indextr].sage_nominal_codes" :key="index_nominal">
                      {{ nominal_code.name }} ,
                    </span>
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    <div class="justify-start vx-row">
                      <vx-tooltip text="View/Update" position="left">
                        <vs-button @click.stop="onClickUpdate(data[indextr])"  class="ml-3"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit-2"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                </vs-tr>
              </template>

            </vs-table>
            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vs-pagination>


          </div>
        </div>
      </vx-card>
    </div>
    <add-new-regions-pop-up ref="addNewRegionsPopUp"/>
    <create-sage-departments-pop-up ref="createSageDepartmentsPopUp"/>
  </div>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory';
  import AddNewRegionsPopUp from "@/components/popups/settings/regions/AddNewRegionsPopUp";
  import CreateSageDepartmentsPopUp from "@/components/popups/settings/sage-departments/CreateSageDepartmentsPopUp";
  import vSelect from 'vue-select'

  import Filter from '@/mixins/filter';
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  import {defaultPagination, perPageList} from "@/constants/config";

  const RegionsRepository = RepositoryFactory.get('regions');
  const SageSettingsRepository = RepositoryFactory.get('sage_settings');

  export default {
    name: "CcpItemSettings",
    data() {
      return {
        sage_departments: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
      }
    },
    components: {
      AddNewRegionsPopUp,
      CreateSageDepartmentsPopUp,
      'v-select': vSelect,
    },
    methods: {
      async refreshData() {
        await this.fetchSageDepartments()
      },
      async fetchSageDepartments() {
        await this.$vs.loading({
          container: '#sage-department-table',
          scale: 0.45
        })
        const {data} = await SageSettingsRepository.getListOfSageDepartments(this.page, this.filterQuery, this.perPage, this.sort)
        this.sage_departments =  data.data
        this.meta = data.meta
        this.$vs.loading.close('#sage-department-table > .con-vs-loading')
      },
      async onClickAdd() {
        await this.$refs.createSageDepartmentsPopUp.openPopup()
      },
      async onClickUpdate(data) {
        await this.$refs.createSageDepartmentsPopUp.openPopup(data)
      },
      filterQueryUpdate (){
        this.fetchSageDepartments()
      },

      handleChangePage(page) {
        this.page=page;
        this.fetchSageDepartments()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.fetchSageDepartments()
        }
      },
      changePage(index) {
        this.perPage = this.descriptionItems[index]
      },
    },
    async mounted() {
      await this.fetchSageDepartments()
    },
    mixins: [Filter, SuccessMessage, ErrorMessages],
     watch : {
      page(){
        this.fetchSageDepartments()
      },
      perPage() {
        this.fetchSageDepartments()
      }
    }
  }
</script>

<style scoped>

</style>
